import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'hoursandminutes'})
export class HoursandminutesPipe implements PipeTransform {
	transform(val: any = null): any {
		if (!val) {
			return null;
		}
		// 2020-08-14T13:14:34.867
		const dateL = '2020-08-14T'.length;
		return val.substring(dateL, dateL + 5);
	}
}
